import type {
  AutomationFeatureSubType,
  ReputationGenerationStatusResponse,
  ReputationImageStyle,
} from '@reach/shared-types/automation-template';
import type { ApiResponse } from '../../../../lib/api';
import { apiRequest } from '../../../../lib/api-utils';
import { API_ENDPOINTS } from '../../../../lib/constants';

export interface ReputationDefaultTemplate {
  /** Identifier the add endpoint expects — never a display string. */
  name: string;
  displayName: string;
  featureSubType: AutomationFeatureSubType;
  alreadyAdded: boolean;
}

export interface AddReputationDefaultsRequest {
  templateNames: string[];
  /** The vertical the partner's tenants serve. Omitted when the partner skips generation. */
  verticalDescription?: string;
  includeImages?: boolean;
  imageStyle?: ReputationImageStyle;
}

export interface AddReputationDefaultsResult {
  success: boolean;
  createdCount: number;
  templateIds?: string[];
  /** Present only when a generation run was enqueued. */
  generationJobId?: string;
}

export async function getReputationDefaults(): Promise<ReputationDefaultTemplate[]> {
  const response = await apiRequest<ApiResponse<{ templates: ReputationDefaultTemplate[] }>>(
    API_ENDPOINTS.AUTOMATION_TEMPLATES.REPUTATION_DEFAULTS,
  );
  return response.data.templates;
}

export async function addReputationDefaults(
  request: AddReputationDefaultsRequest,
): Promise<AddReputationDefaultsResult> {
  const response = await apiRequest<ApiResponse<AddReputationDefaultsResult>>(
    API_ENDPOINTS.AUTOMATION_TEMPLATES.REPUTATION_DEFAULTS,
    {
      method: 'POST',
      body: JSON.stringify(request),
    },
  );
  return response.data;
}

export async function getReputationGenerationStatus(
  jobId: string,
): Promise<ReputationGenerationStatusResponse> {
  const response = await apiRequest<ApiResponse<ReputationGenerationStatusResponse>>(
    API_ENDPOINTS.AUTOMATION_TEMPLATES.REPUTATION_GENERATION_STATUS(jobId),
  );
  return response.data;
}
